module.exports = __webpack_public_path__ + "static/img/zhong22.e201d11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong22.png
// module id = cZdo
// module chunks = 16